import { IControl } from "commons/ultilities/dynamic-form/models/control";
import { IAddEditWorkOrderPo } from "mobx-stores/_models/work-order-po/work-order-po";
import { useCallback } from "react";
import { useCalcTotalPageWeight } from "./use-calc-total-page-weight";
import { useParchaseOrderItemValueChanged } from "./use-purchase-order-item-changed";
import { useParchaseOrderValueChanged } from "./use-purchase-order-value-changed";

export const useFormValueChanged = ({
  getControl,
}: {
  getControl: (fieldName: keyof IAddEditWorkOrderPo) => IControl;
}) => {
  const { onPurchaseOrderIdChanged } = useParchaseOrderValueChanged({
    getControl,
  });

  const { onPurchaseOrderItemIdChanged, selectedProduct } =
    useParchaseOrderItemValueChanged({
      getControl,
    });

  const { calcTotalPaperWeight } = useCalcTotalPageWeight({
    getControl,
    selectedProduct,
  });

  const onValueChanged = useCallback(
    async (control: IControl) => {
      if (control.name === "purchaseOrderId") {
        onPurchaseOrderIdChanged(control.value);
      }

      if (control.name === "purchaseOrderItemId") {
        const product = await onPurchaseOrderItemIdChanged(control?.value);

        const totalPaperWeight = calcTotalPaperWeight(product);
        await getControl("totalPaperWeight")?.setValueAndValidate(
          totalPaperWeight,
        );
      }

      if (
        control.name === "poItemFirstFullPaperAmount" ||
        control.name === "poItemSecondFullPaperAmount"
      ) {
        const totalPaperWeight = calcTotalPaperWeight();
        await getControl("totalPaperWeight")?.setValueAndValidate(
          totalPaperWeight,
        );
      }

      if (
        control.name === "productionAmount" ||
        control.name === "poItemProductionAmount"
      ) {
        await Promise.all([
          getControl("productionAmount").validate(),
          getControl("poItemProductionAmount").validate(),
        ]);
      }
    },
    [
      calcTotalPaperWeight,
      getControl,
      onPurchaseOrderIdChanged,
      onPurchaseOrderItemIdChanged,
    ],
  );
  return {
    onValueChanged,
  };
};
